import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { format, parse } from 'date-fns';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Icon from 'components/DesignSystem/Icon';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import {
  Chart, DATE_FORMAT, Runtime,
} from 'helper/products/synopticCharts';
import {
  selectChart,
  selectDate,
  selectRuntime,
} from 'redux/reducers/synopticChartsReducer';
import useGetOptions from 'utils/hooks/synopticCharts/useGetOptions';
import useInitialLoad from 'utils/hooks/synopticCharts/useInitialLoad';
import { cssVar } from 'constants/theme';
import ChartViewer from './ChartViewer';
import ControlPanelSheet from './ControlPanelSheet';

import './index.scss';

export default function SynopticChartsMobile() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const { monitoringOptions, runtimes, isLoading } = useGetOptions();

  useInitialLoad({ monitoringOptions, runtimes, isLoading });

  const chart: Chart | undefined = useSelector(selectChart);
  const date: string | undefined = useSelector(selectDate);
  const runtime: Runtime | undefined = useSelector(selectRuntime);

  const dateLabel = date ? format(parse(date, DATE_FORMAT, new Date()), 'dd/MM/yyyy') : undefined;
  const querySubtitle = [dateLabel, runtime?.label].filter(Boolean).join(' · ');

  return (
    <div className="sc-mobile">
      <QueryCard>
        {chart && (
          <QueryCardHeader
            label="Consulta atual"
            title={chart.campo}
            subtitle={querySubtitle}
            action={chart.descricao ? (
              <button
                type="button"
                className="sc-mobile-info-button"
                aria-label="Sobre o campo"
                onClick={() => setInfoOpen(true)}
              >
                <Icon iconType="info" size="small" color={cssVar('text-accent')} />
              </button>
            ) : undefined}
          />
        )}
        <QueryCardTrigger onClick={() => setPanelOpen(true)} hint="Campo · Data · Runtime" />
      </QueryCard>

      <ChartViewer />

      <ControlPanelSheet open={panelOpen} dismiss={() => setPanelOpen(false)} />

      <BottomSheet
        open={infoOpen}
        dismiss={() => setInfoOpen(false)}
        title={(
          <>
            <span className="sc-mobile-info-sheet-label">Sobre o campo</span>
            <span className="sc-mobile-info-sheet-chart">{chart?.campo}</span>
          </>
        )}
      >
        <p className="sc-mobile-info-sheet-text">{chart?.descricao}</p>
      </BottomSheet>
    </div>
  );
}
